// import variables from '../variables';
/* eslint-disable */
const MuiCssBaseline = {
  '@global': {
    html: {
      WebkitFontSmoothing: 'auto',
    },
  },
};
export default MuiCssBaseline;
